module.exports = __webpack_public_path__ + "img/play-button.53f73d54.png";